const UTILS = {
    async PromisesSequential(PromiseArr) {
      let res = []
      for (let i = 0; i < PromiseArr.length; i++) {
        res.push(await PromiseArr[i])
      }
      return res
    },
    ConvertStringToHTML(str) {
      let parser = new DOMParser()
      let doc = parser.parseFromString(str, 'text/html')
      return doc.body
    },
    ConvertStringToJS(str) {
      var script = document.createElement("script")
      script.text = str
      document.head.appendChild(script).parentNode.removeChild(script)
    },
    ObserveIntersection(elementSelector, config, callback) {
      let observer = new IntersectionObserver(callback, config);
      let node = typeof elementSelector == 'string' ? document.querySelector(elementSelector) : elementSelector
      observer.observe(node, config);  
      return observer;
    }
  };
  
  (() => {
    document.addEventListener('alpine:init', () => {
Alpine.data('HoverContent', (handle) => ({
  image_1: null,
  heading_1: null,
  heading_1_color: null,
  link_1: null,
  overlay_1:null,
  image_2: null,
  heading_2: null,
  heading_2_color: null,
  link_2: null,
  overlay_2:null,
  image_3: null,
  heading_3: null,
  heading_3_color: null,
  link_3: null,
  overlay_3:null,
  title: null,
  hasLifestyleImage: false,
  hasImage1: false,
  hasImage2: false,
  hasImage3: false,
  mounted() {
    let am = this
    am.LoadHover()
  
    let hoverItems = am.$el.querySelectorAll('.hover-me')
    let childLists = am.$el.querySelectorAll('.mega-menu__child-list')
        
    // Check if any hover-me element already has active-hover class
    let hasActiveHover = false;
    for (let i = 0; i < hoverItems.length; i++) {
      if (hoverItems[i].classList.contains('active-hover')) {
        hasActiveHover = true;
        break;
      }
    }
    
    // If no active hover, activate the first one
    if (!hasActiveHover && hoverItems.length > 0) {
      const firstHoverItem = hoverItems[0];
      firstHoverItem.classList.add('active-hover');
      
      // Get the link data and show the corresponding child list
      const linkId = firstHoverItem.getAttribute('data-linklist');
      const linkLoop = firstHoverItem.getAttribute('data-loop');
      
      // Hide all child lists
      for (let i = 0; i < childLists.length; i++) {
        childLists[i].style.display = 'none';
      }
      
      // Show the first child list
      if (linkId) {
        am.$el.querySelector('#' + linkId)?.style.setProperty('display', 'flex');
      }
      
      // Set the hover content
      if (linkLoop) {
        am.link.first = am.link.childlinks.find(v => v.loop == linkLoop);
        if (am.link.first) {
          am.SetHoverContent();
        }
      }
    }
    
    new SV.HoverIntent(hoverItems, {
      onEnter: function(targetItem) {
        console.log('hover')
        let myEvent = targetItem;
        let link_loop = myEvent.getAttribute('data-loop')
        let link_id = myEvent.getAttribute('data-linklist')
        
        // Remove active-hover from items in THIS menu only
        for (let i = 0; i < hoverItems.length; ++i) {
          hoverItems[i].classList.remove('active-hover')
        }
        myEvent.classList.add('active-hover')
        am.link.first = am.link.childlinks.find(v => v.loop == link_loop )
        
        // hide all childlists - use scoped selector
        let menuChildLists = am.$el.querySelectorAll('.mega-menu__child-list')
        for (let i = 0; i < menuChildLists.length; ++i) {
          menuChildLists[i].style.display = 'none'
        }
        
        // show this one
        if (link_id) {
          const element = document.getElementById(link_id);
          if (element) element.style.display = 'flex';
        }
        
        // set hover content on the right
        if (am.link.first){
          am.SetHoverContent()
        }
      },
      onExit: function(targetItem) {
      }
    });

    // Click/touch fallback - fires on all devices
    hoverItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        let link_loop = item.getAttribute('data-loop');
        let link_id = item.getAttribute('data-linklist');

        // Remove active-hover from all items in this menu
        for (let i = 0; i < hoverItems.length; i++) {
          hoverItems[i].classList.remove('active-hover');
        }
        item.classList.add('active-hover');

        // Hide all child lists scoped to this menu
        let menuChildLists = am.$el.querySelectorAll('.mega-menu__child-list');
        for (let i = 0; i < menuChildLists.length; i++) {
          menuChildLists[i].style.display = 'none';
        }

        // Show the selected child list
        if (link_id) {
          const element = am.$el.querySelector('#' + link_id);
          if (element) element.style.display = 'flex';
        }

        // Update image promos
        am.link.first = am.link.childlinks.find(v => v.loop == link_loop);
        if (am.link.first) {
          am.SetHoverContent();
        }
      });
    });

    // active state on parent menu
    new SV.HoverIntent(childLists, {
      onEnter: function(targetItem) {
        let link_id = targetItem.id
        // Scope the selector to this component
        let parentList = am.$el.querySelector('.hover-me[data-linklist="'+link_id+'"]')
        if (parentList) parentList.classList.add('active-hover');
      },
      onExit: function(targetItem) {
        let link_id = targetItem.id
        // Scope the selector to this component
        let parentList = am.$el.querySelector('.hover-me[data-linklist="'+link_id+'"]')
        if (parentList) parentList.classList.remove('active-hover');
      }
    });
  },
  
  LoadHover() {
    let am = this
    const template = am.$el.querySelector('[data-mega-json-' + handle + ']')
    am.link = JSON.parse(template.innerHTML)
  },
  
  SetHoverContent() {
    let am = this
    let title = am.link.first.title
    let image_1 = am.link.first.image_1
    let heading_1 = am.link.first.heading_1
    let link_1 = am.link.first.link_1
    let overlay_1 = am.link.first.overlay_1 ? am.link.first.overlay_1 / 100.00 : 0
    let heading_1_color = am.link.first.heading_1_color
    let image_2 = am.link.first.image_2
    let heading_2 = am.link.first.heading_2
    let heading_2_color = am.link.first.heading_2_color
    let link_2 = am.link.first.link_2
    let overlay_2 = am.link.first.overlay_2 ? am.link.first.overlay_2 / 100.00 : 0
    let image_3 = am.link.first.image_3
    let heading_3 = am.link.first.heading_3
    let heading_3_color = am.link.first.heading_3_color
    let link_3 = am.link.first.link_3
    let overlay_3 = am.link.first.overlay_3 ? am.link.first.overlay_3 / 100.00 : 0
    
    am.title = title
    am.image_1 = image_1
    am.heading_1 = heading_1
    am.heading_1_color = heading_1_color
    am.link_1 = link_1
    am.overlay_1 = overlay_1
    am.image_2 = image_2
    am.heading_2 = heading_2
    am.heading_2_color = heading_2_color
    am.link_2 = link_2
    am.overlay_2 = overlay_2
    am.image_3 = image_3
    am.heading_3 = heading_3
    am.heading_3_color = heading_3_color
    am.link_3 = link_3
    am.overlay_3 = overlay_3
    
    am.image_1 ? am.hasImage1 = true : am.hasImage1 = false;
    am.image_2 ? am.hasImage2 = true : am.hasImage2 = false;
    am.image_3 ? am.hasImage3 = true : am.hasImage3 = false;

    am.hasImage1 || am.hasImage2 || am.hasImage3 ? am.hasLifestyleImage = true : am.hasLifestyleImage = false;
  },
  
  GetImageSrcset(src) {
    // Check if src exists before trying to use it
    if (!src) return '';
    return `${src}&width=550 550w, ${src}&width=672 1100w, ${src}&width=672 1445w, ${src}&width=672 2048w`
  },
  
  GetImageUrl(src, width) {
    // Check if src exists before trying to use it
    if (!src) return '';
    return `${src}&width=${width}`
  }
}))
 })
  })()